import S from 's-js';
import { lift } from 's-array';
import { IAjax } from 'lib/Ajax';
import { debounceSignal } from 'lib/debounceSignal';
import * as _ from 'underscore';

import { Entrypoints } from 'core/app/entrypoints';
import { VesselServiceListingData } from 'data/models/VesselServiceListing';
import { Vessel } from 'data/models/Vessel';
import { VesselStatus } from 'server/enums/VesselStatus';
import { VesselServiceListingCache } from './cache'; 

export interface VesselServiceListingParams {
    status : VesselStatus | null;
}

export interface VesselModel {
    Model : Vessel;
    OnRowClick : () => void;
}

export function VesselServiceListing (
    ajax : IAjax,
    entrypoints : Entrypoints,
    cache : VesselServiceListingCache,
    { status } : VesselServiceListingParams
) {
    const searchText  = S.data("");

    const key = () => ({
        Status : status,
        SearchString : searchText()
    });

    const model = S(() => cache.VesselServiceListings.update1(null, key()));

    S.on(debounceSignal(searchText), () => {
        if(searchText().length >= 3)
        {
            var searchRequest = ajax.Url<VesselServiceListingData>(entrypoints.VesselServiceListing(key())).Get();
            searchRequest.done(json =>{
                cache.VesselServiceListings.update1(searchRequest.Date, json);
            });
        }
    });

    return {
        Model: model,
        Vessels: lift(() => model().Vessels()).map(VesselModel),
        SearchText: searchText,
        GoBack: () => window.history.back()
    };

    function VesselModel(vessel : Vessel) : VesselModel {
        return {
            Model: vessel,
            OnRowClick: () => window.location.hash = '#!vesselserviceprofile?id=' + vessel.Id()
        };
    }
}
export type VesselServiceListing = ReturnType<typeof VesselServiceListing>;


// WEBPACK FOOTER //
// ./apps/portcall/vesselservicelisting/model.ts